import { SET_IMAGE_CUSTOM_METADATA } from "./constants";

const INITIAL_STATE = {
  imageCustomMetadata: [],
};

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_IMAGE_CUSTOM_METADATA:
      return { ...state, imageCustomMetadata: action.data };

    default:
      return state;
  }
};

export default reducer;
